// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OMhS","top":"styles_top__tKaY2","left":"styles_left__2gCxn","description":"styles_description__2feqb"};